export const SET_HEADSET_ACCOUNT = 'SET_HEADSET_ACCOUNT'
export const SET_WEEDMAP_ACCOUNT = 'SET_WEEDMAP_ACCOUNT'
export const SET_WEBHOOKS = 'SET_WEBHOOKS'
export const SET_HUBLIST = 'SET_HUBLIST'
export const SET_EMPLOYEE_LIST = 'SET_EMPLOYEE_LIST'
export const SET_TEAM_LIST = 'SET_TEAM_LIST'
export const SET_SPRING_BIG_LIST = 'SET_SPRING_BIG_LIST'
export const SET_TOOKAN_ACCOUNT_LIST = 'SET_TOOKAN_ACCOUNT_LIST'
export const SET_TOOKAN_TEAM_LIST = 'SET_TOOKAN_TEAM_LIST'
export const SET_WEEDMAP_TAGS = 'SET_WEEDMAP_TAGS'
export const SET_SPENCE_ACCOUNT_LIST = 'SET_SPENCE_ACCOUNT_LIST'
export const SET_ACH_ACCOUNT_LIST = 'SET_ACH_ACCOUNT_LIST'
export const SET_DCH_DISABLED_SHOP_LIST = 'SET_DCH_DISABLED_SHOP_LIST'



// WEBPACK FOOTER //
// ./src/types/integration.js